/* Ability Warehouse — membership "first 2 months free" windows + live countdown (v39).
   The windows are the `free` lines of Theme settings → Sale calendar (start|end|0|name|free), passed in as window.CW.offers
   ([["2026-11-17","2026-11-30"], …]). A window runs from 00:00 on its start date to 00:00 the day after its end date,
   Sydney time — the same instants as the scheduled "Membership – first 2 months free" automatic discounts.
   Liquid (snippets/member-offer.liquid) renders the right wording server-side; this script keeps it right if a cached page
   crosses a window edge, and runs the countdowns:
     [data-awo-txt data-on="…" data-off="…"]  text swapped to data-on during a window, data-off outside
     [data-awo-cd] containing [data-awo-t]    shown only during a window: "Offer ends in 3d 04h 12m" (ticks each minute)
     [data-free-month]                        set to "true"/"false" (cart line property used by cart-drawer.js) */
(function () {
  'use strict';
  var W = ((window.CW || {}).offers || []).filter(function (w) { return w && /^\d{4}-\d{2}-\d{2}$/.test(w[0]) && /^\d{4}-\d{2}-\d{2}$/.test(w[1]); });
  var fmtTz = null;
  try { fmtTz = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch (e) {}
  /* Minutes Sydney is ahead of UTC at instant ms (600 or 660) */
  function sydOffset(ms) {
    if (!fmtTz || !fmtTz.formatToParts) return 600;
    var o = {};
    fmtTz.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
    var asUtc = Date.UTC(+o.year, +o.month - 1, +o.day, (+o.hour) % 24, +o.minute, +o.second);
    return Math.round((asUtc - ms) / 60000);
  }
  /* Instant of 00:00 Sydney time on the ISO date `iso` plus `add` days */
  function sydMidnight(iso, add) {
    var a = iso.split('-');
    var g = Date.UTC(+a[0], +a[1] - 1, +a[2] + (add || 0));
    var t = g - sydOffset(g) * 60000;
    return g - sydOffset(t) * 60000;
  }
  var wins = W.map(function (w) { return { start: sydMidnight(w[0], 0), end: sydMidnight(w[1], 1) }; });
  function active(now) {
    now = now == null ? Date.now() : now;
    for (var i = 0; i < wins.length; i++) if (now >= wins[i].start && now < wins[i].end) return wins[i];
    return null;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  /* "3d 04h 12m" / "4h 12m" / "12m" — whole minutes, rounded up so it never shows 0m while time remains */
  function left(ms) {
    var m = Math.max(0, Math.ceil(ms / 60000)), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    if (d > 0) return d + 'd ' + pad(h) + 'h ' + pad(mm) + 'm';
    if (h > 0) return h + 'h ' + pad(mm) + 'm';
    return mm + 'm';
  }
  function set(el, prop, v) { if (el[prop] !== v) el[prop] = v; }
  function paint() {
    var now = Date.now(), w = active(now), on = !!w;
    document.documentElement.classList.toggle('awo-on', on);
    Array.prototype.forEach.call(document.querySelectorAll('[data-awo-txt]'), function (el) {
      var t = on ? el.getAttribute('data-on') : el.getAttribute('data-off');
      if (t != null) set(el, 'textContent', t);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-awo-cd]'), function (el) {
      set(el, 'hidden', !on);
      if (!on) return;
      var t = el.querySelector('[data-awo-t]'), txt = left(w.end - now);
      if (t) set(t, 'textContent', txt);
      var lbl = 'Offer ends in ' + txt;
      if (el.getAttribute('aria-label') !== lbl) el.setAttribute('aria-label', lbl);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-free-month]'), function (el) {
      var v = on ? 'true' : 'false';
      if (el.getAttribute('data-free-month') !== v) el.setAttribute('data-free-month', v);
    });
    schedule(w, now);
  }
  var timer = 0;
  function schedule(w, now) {
    clearTimeout(timer);
    var next = 60000;
    if (w) { var rem = (w.end - now) % 60000; next = rem > 0 ? rem + 20 : 60000; }
    else {
      for (var i = 0; i < wins.length; i++) if (wins[i].start > now) { next = Math.min(next, wins[i].start - now + 20); }
    }
    timer = setTimeout(paint, Math.max(1000, Math.min(next, 60000)));
  }
  window.AWOffer = { active: function () { return !!active(); }, end: function () { var w = active(); return w ? w.end : null; }, paint: paint, _left: left, _wins: wins };
  if (!wins.length) return;
  paint();
  /* The cart drawer / cart page re-render from section HTML: repaint new nodes (paint only writes on change, so no loop) */
  var queued = false;
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (queued) return; queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; paint(); });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) paint(); });
})();
